import React from 'react';

import autoBind from 'react-autobind';
import Switch, { Case } from 'react-switch-case';

// import other components within the same project here

import Localization from "composer/Localization.jsx"

import RootPage from "composer/pages/RootPage.jsx"

import LocaleMapView from "composer/views/locale/LocaleMapView.jsx";
import LocaleListView from "composer/views/locale/LocaleListView.jsx";
import LocaleViewerBar from "composer/views/locale/LocaleViewerBar.jsx";
import CreateLocaleDialog from "composer/views/locale/CreateLocaleDialog.jsx";
import EditLocaleDialog from "composer/views/locale/EditLocaleDialog.jsx";
import LocaleMapState from "composer/views/locale/LocaleMapState.jsx"
import ProgressDialog from "composer/views/ProgressDialog.jsx"
import * as MapTile from "composer/tools/MapTile.js"
import LocaleOverviewDialog from "composer/views/locale/LocaleOverviewDialog.jsx"

const VIEW_LOCALE_LIST    = 0;
const VIEW_LOCALE_MAP     = 1;

const MAX_ROW_PER_PAGE    = 12;

class LocaleViewerPage extends React.Component {
  static VIEW_LOCALE_LIST() {
    return VIEW_LOCALE_LIST;
  }
  static VIEW_LOCALE_MAP() {
    return VIEW_LOCALE_MAP;
  }

  getSteps() {
    return [Localization.strings.DETAILS, Localization.strings.COVER_IMAGE, Localization.strings.LOCATION, Localization.strings.PUBLISH];
  }

  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      currentView: VIEW_LOCALE_LIST,
      localeList: [],
      localeListInMap: [],
      localeZoom: 12,
      filterSchoolID: props.root.getMySchoolId(),
      filterUserID: props.root.getMyUserId(),
      filterKLA: 0,
      filterSubject: 0,
      filterSubmission: 0,
      filterKeyword: "",
      currentLocale: null,
      localeID: -1,
      localeIndex: -1,
      totalLocale: 0,
      totalPage: 0,
      currentPage: 0,
      tileLength: 0,
      isViewPublic: false,
      active: true,
      showPublicOnly: 0,
      qaState: -1,
    };
    autoBind(this);


    this.refreshLocaleList();
  }

  componentDidMount() {
    // this.props.root.setTitle("LOCALE LIST !!!!")
  }

  // return a string that summarize the current LOCALE searching filters
  // used for title display, return empty string if there is no filter
  getFilterString(){
    return "filter string!!";
  }

  updateMapState() {
    if (this.refs.localeMapState != null) {
      this.refs.localeMapState.updateState();
    }
  }

  changeView(view) {
    this.updateMapState();

    this.setState({
      currentView: view
    });
    this.state.currentView = view;

    if (view == VIEW_LOCALE_MAP) {
      this.refreshLocaleList();
    }
  }

  getLocaleListOK(res) {

    if (this.state.currentView == VIEW_LOCALE_MAP) {
      this.setState({localeListInMap:res.body['result']});
      this.state.localeListInMap = res.body['result'];
      // this.props.root.setCurrentLocale(null); hot-fix
    }
    else {
      this.setState({localeList:res.body['result']});
      this.state.localeList = res.body['result'];
      this.props.root.setCurrentLocale(this.state.currentLocale);
      let count = res.body.count;
      let page = Math.ceil(count / MAX_ROW_PER_PAGE);
      this.setState({
        totalLocale: count,
        totalPage: page,
      });
      this.state.totalLocale = count;
      this.state.totalPage = page;
    }
  }

  getLocaleListFailed(err) {
    console.log("getLocaleListFailed");
  }

  filterLocaleBySchoolAndUserId(schoolId, userId){
    this.setState({
      filterSchoolID: schoolId,
      filterUserID: userId,
    });
    this.state.filterSchoolID = schoolId;
    this.state.filterUserID = userId;

    this.filterLocaleList(this.state.filterSchoolID, this.state.filterUserID);
  }

  filterLocaleByKLA(kla) {
    if (kla >= 0) {
      this.setState({ filterKLA: kla });
      this.state.filterKLA = kla;
    }
    this.changePage(0, false);
    this.filterLocaleList(this.state.filterSchoolID, this.state.filterUserID, this.state.filterKLA);
  }

  filterLocaleBySubject(subject) {
    if (subject >= 0) {
      this.setState({ filterSubject: subject });
      this.state.filterSubject = subject;
    }
    this.changePage(0, false);
    this.filterLocaleList(this.state.filterSchoolID, this.state.filterUserID, this.state.filterKLA, this.state.filterSubject);
  }

  filterLocaleBySubmission(ownSubmission) {
    if (ownSubmission >= 0 ) {
      this.setState({filterSubmission: ownSubmission});
      this.state.filterSubmission = ownSubmission;
    }
    this.changePage(0, false);
    this.filterLocaleList(this.state.filterSchoolID, this.state.filterUserID, this.state.filterKLA, this.state.filterSubject, this.state.filterSubmission);
  }

  filterLocaleByKeyword(keyword) {
    this.setState({ filterKeyword: keyword });
    this.state.filterKeyword = keyword;
    this.changePage(0, false);
    this.filterLocaleList(this.state.filterSchoolID, this.state.filterUserID, this.state.filterKLA, this.state.filterSubject, this.state.filterSubmission, this.state.filterKeyword);
  }

  filterLocaleList(schoolID, userID, kla, subject, own_submission, keyword) {
    this.updateMapState();
    let requestObj= {
      table: "epack",
      is_editor: "1",
      filter: {
      },
      order_by: (this.refs.localeViewerBar? this.refs.localeViewerBar.state.localeSortField : "epack.id"),
      order_mode: (this.refs.localeViewerBar? this.refs.localeViewerBar.state.localeSortOrder : "DESC"),
    };

    if (schoolID) {
      requestObj.filter['epack.school_id'] = schoolID;
    }
    if (userID) {
      requestObj.filter['epack.user_id'] = userID;
    }
    if (kla) {
      requestObj.filter["epack.kla"] = kla;
    }
    if (subject) {
      requestObj.filter["epack.subject"] = subject;
    }
    if (own_submission) {
      requestObj["own_submission"] = own_submission;
      requestObj.filter["submission.school_id"] = this.props.root.getMySchoolId();
    }
    if (keyword) {
      requestObj.filter["epack.name"] = keyword;
    }
    if (this.state.currentView == VIEW_LOCALE_MAP) {
      if (this.refs.localeMapView != null) {
        let bounds = this.refs.localeMapState.state.bounds;
        requestObj.filter["ul_lat"] = bounds.ul.lat;
        requestObj.filter["ul_lon"] = bounds.ul.lon;
        requestObj.filter["br_lat"] = bounds.br.lat;
        requestObj.filter["br_lon"] = bounds.br.lon;
      }
    }
    else {
      requestObj.current_page = this.state.currentPage;
      requestObj.row_per_page = MAX_ROW_PER_PAGE;
    }

    if (this.props.root.isAdminUser()) {
      requestObj["show_public_only"] = this.state.showPublicOnly;
    }

    if (this.state.qaState >= 0) {
      requestObj.filter['qa_state'] = this.state.qaState;
    }

    this.props.root.refs.API.request("get_list_epack", requestObj, this.getLocaleListOK, this.getLocaleListFailed);
  }

  clearLocaleFilter() {
    let viewPublic = this.state.isViewPublic;
    this.changePage(0);
    this.setState({
      filterSchoolID: (viewPublic? null : this.props.root.getMySchoolId()),
      filterUserID: (viewPublic? null : this.props.root.getMyUserId()),
      filterKLA: 0,
      filterSubject: 0,
      filterKeyword: ""
    });
    this.state.filterSchoolID = (viewPublic? null : this.props.root.getMySchoolId());
    this.state.filterUserID = (viewPublic? null : this.props.root.getMyUserId());
    this.state.filterKLA = 0;
    this.state.filterSubject = 0;
    this.state.filterKeyword = "";
  }

  refreshLocaleList() {
    this.filterLocaleList(this.state.filterSchoolID, this.state.filterUserID, this.state.filterKLA, this.state.filterSubject, this.state.filterSubmission, this.state.filterKeyword);
  }

  setLocaleCenter(center) {
    this.refs.localeMapState.setCenter(center);
  }

  showLocaleInfo(index) {
    if (this.state.currentView == VIEW_LOCALE_MAP) {
      this.props.root.setCurrentLocale(this.state.localeListInMap[index]);
    }
    else {
      this.props.root.setCurrentLocale(this.state.localeList[index]);
    }
    this.refs.editLocaleDialog.setState({open: true});
    this.refs.editLocaleDialog.changeTab(this.refs.editLocaleDialog.state.activeTab);
    this.setState({ localeIndex: index });
    this.state.localeIndex = index;
  }

  overviewLocale(index) {
    if (this.state.currentView == VIEW_LOCALE_MAP) {
      this.props.root.setCurrentLocale(this.state.localeListInMap[index]);
    }
    else {
      this.props.root.setCurrentLocale(this.state.localeList[index]);
    }

    this.refs.overviewLocaleDialog.refresh();
    this.refs.overviewLocaleDialog.setState({
      open: true,
      localeIndex: index,
    });
    this.refs.overviewLocaleDialog.state.open = true;
  }

  editLocaleByIndex(index) {
    let locale = null;
    if (this.state.currentView == VIEW_LOCALE_MAP) {
      locale = this.state.localeListInMap[index];
    }
    else {
      locale = this.state.localeList[index];
    }
    this.setState({ localeIndex: index });
    this.state.localeIndex = index;

    this.editLocale(locale);
  }

  editLocale(locale, changeHistory=true) {
    this.setState({ currentLocale: locale });
    this.state.currentLocale = locale;
    this.props.root.setCurrentLocale(locale);
    this.props.root.changeStatus(this.props.parent.STATUS_VIEW_HOTSPOT());

    if (changeHistory) {
      this.props.root.pushHistory("locale/hotspot", {locale: locale});
    }
  }

  retrieveAnswerByIndex(index) {
    let locale = null;
    if (this.state.currentView == VIEW_LOCALE_MAP) {
      locale = this.state.localeListInMap[index];
    }
    else {
      locale = this.state.localeList[index];
    }

    this.retrieveAnswer(locale);
  }

  retrieveAnswer(locale, changeHistory=true) {
    this.setState({ currentLocale: locale });
    this.state.currentLocale = locale;
    this.props.root.setCurrentLocale(locale);
    this.props.root.changeStatus(this.props.parent.STATUS_VIEW_RETRIEVER());

    if(this.props.root.isAdminUser() || (this.props.root.getSameSchoolEdit() && locale.school_id == this.props.root.getMySchoolId()) || this.props.root.getMyUserId() == locale.user_id){
      // console.log('send set 11 req');
      this.props.root.refs.API.request('reset_epack_submission_new', {epack_id:locale.id});
      this.refreshLocaleList();
    }

    if (changeHistory) {
      this.props.root.pushHistory("locale/retriever", {locale: locale});
    }
  }

  deleteLocale(id) {
    this.setState({ localeID: id});
    this.state.localeID = id;
    let dialogText = {
      title: Localization.strings.DELETE_LOCALE,
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    };
    this.props.root.refs.confirmDialog.show(dialogText, this.deleteLocaleConfirmClicked, this.deleteLocaleCancelClicked);
  }

  deleteLocaleConfirmClicked() {
    if (this.state.localeID >= 0) {
      let requestObj = {table: "epack",filter: { id: this.state.localeID }};
      this.props.root.refs.API.request("delete", requestObj, this.deleteLocaleOK, this.deleteLocaleFails);
    }
    this.setState({ localeID: -1 });
    this.state.localeID = -1;
  }

  deleteLocaleCancelClicked() {
    this.setState({ localeID: -1 });
    this.state.localeID = -1;
  }

  deleteLocaleOK(res) {
    this.refreshLocaleList();
    this.props.root.addNotification(Localization.strings.DELETED, true);
  }

  deleteLocaleFail(err) {
    console.log("delete locale fail");
    this.props.root.addNotification(Localization.strings.DELETE_FAILED, false);
  }

  previousPage() {
    let page = this.state.currentPage;
    page--;
    if (page < 0) {
      page = 0;
    }
    this.changePage(page);
  }

  nextPage() {
    let page = this.state.currentPage;
    page++;
    if (page > this.state.totalPage - 1) {
      page = this.state.totalPage - 1;
    }
    this.changePage(page);
  }

  changePage(page, refresh=true) {
    this.setState({ currentPage: page });
    this.state.currentPage = page;
    if (refresh) {
      this.refreshLocaleList();
    }
  }

  createMapTile(upperLeftLatLon, bottomRightLatLon) {
    MapTile.findAllTileDataList(upperLeftLatLon, bottomRightLatLon, this.findMapTileComplete);
    this.refs.progressDialog.show(null, this.createMapTileDone);
  }

  createMapTileDone() {
    if (this.refs.createLocaleDialog.state.open) {
      this.refs.createLocaleDialog.createMapTileDone();
    }
    if (this.refs.editLocaleDialog.state.open) {
      this.refs.editLocaleDialog.createMapTileDone();
    }
  }

  findMapTileComplete(length) {
    this.setState({tileLength: length});
    this.state.tileLength = length;
    this.refs.progressDialog.setDescription(Localization.strings.PREPARING + "... 0/" + this.state.tileLength);
    MapTile.downloadAllTileDataList(this.downloadMapTileComplete);
  }

  downloadMapTileComplete(count) {
    this.refs.progressDialog.setProgress(count / this.state.tileLength * 100.0);
    this.refs.progressDialog.setDescription(Localization.strings.PREPARING + "... " + count + "/" + this.state.tileLength);
    if (count == this.state.tileLength) {
      if (this.refs.createLocaleDialog.state.open) {
        this.refs.createLocaleDialog.downloadMapTileComplete();
      }
      if (this.refs.editLocaleDialog.state.open) {
        this.refs.editLocaleDialog.downloadMapTileComplete();
      }
    }
  }

  uploadMapTile(epackID, skip = false) {
    if(!skip){
      this.refs.progressDialog.setDescription(Localization.strings.UPLOADING + "...");
      this.refs.progressDialog.setProgress(0);
      this.refs.progressDialog.setVariant("indeterminate");
      MapTile.uploadAllTileDataList(epackID, this.uploadMapTileComplete);
    }else{
      this.refs.progressDialog.setDescription(Localization.strings.UPLOAD_COMPLETE);
      this.refs.progressDialog.setVariant("determinate");
      this.refs.progressDialog.showDoneButton();
    }
  }

  uploadMapTileComplete(progress) {
    this.refs.progressDialog.setProgress((1-progress) * 100.0);
    if (progress == 0) {
      this.refs.progressDialog.setDescription(Localization.strings.UPLOAD_COMPLETE);
      this.refs.progressDialog.setVariant("determinate");
      this.refs.progressDialog.showDoneButton();
    }
  }

  onViewAngleChanged(e) {
    let isPublic = false;
    switch (e.target.value) {
      case 0:
        isPublic = false;
        break;
      case 1:
        isPublic = true;
        break;
    }

    this.setState({ isViewPublic: isPublic });
    this.state.isViewPublic = isPublic;

    this.ChangeViewAnlge();
  }

  ChangeViewAnlge() {
    this.changePage(0, false);
    this.setState({
      filterSchoolID: (this.state.isViewPublic? null : this.props.root.getMySchoolId()),
      filterUserID: (this.state.isViewPublic? null : this.props.root.getMyUserId()),
    });
    this.state.filterSchoolID = (this.state.isViewPublic? null : this.props.root.getMySchoolId());
    this.state.filterUserID = (this.state.isViewPublic? null : this.props.root.getMyUserId());

    this.refs.localeViewerBar.clearFilter();
    if (!this.state.isViewPublic) {
      this.refs.localeViewerBar.setDefaultUserOption(this.state.filterUserID);
    }

    this.refreshLocaleList();
  }

  onQAStateChanged(e) {
    this.setState({ qaState: e.target.value });
    this.state.qaState = e.target.value;
    this.changePage(0, false);
    this.refreshLocaleList();
  }

  onClearFilter() {
    this.changePage(0, false);
    this.setState({
      filterKLA: null,
      filterSubject: null,
      filterKeyword: null,
    });
    this.state.filterKLA = null;
    this.state.filterSubject = null;
    this.state.filterKeyword = null;
  }

  updateLocalLocaleDataById(locale_id, localeData) {
    let tempLocaleList = this.state.localeList;
    let tempLocaleListInMap = this.state.localeListInMap;
    for (let i = 0; i < tempLocaleList.length; i++) {
      if (tempLocaleList[i]['id'] == locale_id) {
        tempLocaleList[i] = localeData;
      }
    }
    for (let i = 0; i < tempLocaleListInMap.length; i++) {
      if (tempLocaleListInMap[i]['id'] == locale_id) {
        tempLocaleListInMap[i] = localeData;
      }
    }
    this.setState({
      localeList: tempLocaleList,
      localeListInMap: tempLocaleListInMap,
    });
  }

  render() {
      return (
        <div style={{display:(this.state.active ? "": "none")}}>
          <LocaleViewerBar root={this.props.root} parent={this} ref="localeViewerBar"/>
          <CreateLocaleDialog root={this.props.root} parent={this} ref="createLocaleDialog"/>
          <EditLocaleDialog root={this.props.root} parent={this} ref="editLocaleDialog"/>
          <LocaleOverviewDialog root={this.props.root} parent={this} ref="overviewLocaleDialog"/>
          <LocaleMapState root={this.props.root} parent={this} ref="localeMapState"/>
          <ProgressDialog root={this.props.root} parent={this} ref="progressDialog"/>

          <Switch condition={this.state.currentView}>
            <Case value={VIEW_LOCALE_LIST}>
              <LocaleListView root={this.props.root} parent={this}/>
            </Case>
            <Case value={VIEW_LOCALE_MAP}>
              <LocaleMapView root={this.props.root} parent={this} ref="localeMapView"/>
            </Case>
          </Switch>
          </div>
      )
  }
}

export default LocaleViewerPage;
